var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24935 12.8332H8.74935C11.666 12.8332 12.8327 11.6665 12.8327 8.74984V5.24984C12.8327 2.33317 11.666 1.1665 8.74935 1.1665H5.24935C2.33268 1.1665 1.16602 2.33317 1.16602 5.24984V8.74984C1.16602 11.6665 2.33268 12.8332 5.24935 12.8332Z",
    stroke: "black",
    strokeOpacity: 0.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17773 4.47998H8.65107V6.95915",
    stroke: "black",
    strokeOpacity: 0.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65128 4.47998L5.34961 7.78165",
    stroke: "black",
    strokeOpacity: 0.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.63086C5.76917 10.3892 8.23083 10.3892 10.5 9.63086",
    stroke: "black",
    strokeOpacity: 0.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/defaultIcon.1ab29c81602275b31f9a60cb5ee5fd76.svg";
export { ForwardRef as ReactComponent };